<template>
  <div class="empty">
    <SvgIcon iconClass="icon-search-empty" className="icon-empty"></SvgIcon>
    哎呀，没找到，试试其他关键词~
  </div>
</template>

<script>
import SvgIcon from "@/components/SvgIcon";
export default {
  components: {
    SvgIcon,
  },
};
</script>

<style lang="scss" scoped>
.empty {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding-top: 130px;
  color: #999;
  font-size: 14px;
  padding-bottom: 240px;
  .icon-empty {
    width: 130px;
    height: 130px;
  }
}
</style>